import React from "react";

interface IStatusTagProps {
  color: "red" | "orange" | "yellow" | "olive" | "green" | "teal" | "blue" | "violet" | "purple" | "pink" | "brown" | "grey" | "black";
  text?: string;
  style?: React.CSSProperties
  iconStyle?: React.CSSProperties
}
const StatusTag = ({ color, text, style, iconStyle }: IStatusTagProps) => (
  <div style={style}>
    <span
      style={{ position: "relative", top: "2px", ...iconStyle }}
      className={`ui ${color} empty horizontal circular label`}
    />
    {text}
  </div>
);

export default StatusTag;
